import { credentialsForUrl, getCredentials } from "../../shared/utils/Util";

// downloadFile fetches an authenticated binary endpoint and triggers a browser
// download, honoring the server's Content-Disposition filename when present.
// Pass a JSON body to issue a POST (used to request a specific set of signs).
export async function downloadFile(
  url: string,
  fallbackFilename: string,
  contentType: string,
  body?: unknown
): Promise<void> {
  const headers: Record<string, string> = { Authorization: `Basic ${getCredentials()}` };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  const resp = await fetch(url, {
    credentials: credentialsForUrl(url),
    method: body !== undefined ? "POST" : "GET",
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!resp.ok) {
    throw new Error(`request failed with status ${resp.status}`);
  }

  const disposition = resp.headers.get("Content-Disposition") || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : fallbackFilename;

  const blob = await resp.blob();
  const objectURL = window.URL.createObjectURL(new Blob([blob], { type: contentType }));
  const anchor = document.createElement("a");
  anchor.href = objectURL;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(objectURL);
}

// fetchBlobURL fetches an authenticated binary endpoint and returns an object
// URL for in-page display (e.g. a preview iframe). The caller must revoke the
// URL when done.
export async function fetchBlobURL(url: string, contentType: string): Promise<string> {
  const resp = await fetch(url, {
    credentials: credentialsForUrl(url),
    method: "GET",
    headers: { Authorization: `Basic ${getCredentials()}` },
  });
  if (!resp.ok) {
    throw new Error(`request failed with status ${resp.status}`);
  }
  const blob = await resp.blob();
  return window.URL.createObjectURL(new Blob([blob], { type: contentType }));
}

export function slugify(s: string): string {
  return s.replace(/[^a-z0-9]/gi, "_");
}
